import { Link, Stack } from '@chakra-ui/react';
import type { ShiptoDepositCrud } from '@diamond/shared/schema/shipto-deposit';
import { Text } from '@diamond/shared/ui';
import {
  type OrderHistoryPoLookupRow,
  buildOrderDetailHref,
  resolveOrderMetaIdByPo,
} from '@diamond/sol-buyer/utils';
import NextLink from 'next/link';

type HistoryRow =
  ShiptoDepositCrud['getTransactionHistories']['response']['data'][number];

export interface NlbTransactionDetailCellProps {
  row: HistoryRow;
  orders: OrderHistoryPoLookupRow[] | undefined;
  warehouseId: string;
}

export function NlbTransactionDetailCell({
  row,
  orders,
  warehouseId,
}: NlbTransactionDetailCellProps) {
  const orderMetaId = resolveOrderMetaIdByPo(row.po_number, orders);
  const showCancelReason =
    row.movement_type === 'credit_shipto' && row.cancel_reason;

  return (
    <Stack spacing={1}>
      {orderMetaId ? (
        <Link
          as={NextLink}
          href={buildOrderDetailHref(orderMetaId, warehouseId)}
          fontSize="sm"
          color="blue"
          _hover={{ textDecoration: 'underline' }}
        >
          {row.po_number}
        </Link>
      ) : (
        <Text fontSize="sm">{row.po_number}</Text>
      )}
      {showCancelReason ? (
        <Text fontSize="xs" color="gray.600">
          Dibatalkan: {row.cancel_reason}
        </Text>
      ) : null}
    </Stack>
  );
}
